import { Box, Grid, Skeleton } from '@mui/material';
import _ from 'lodash';

export const NewsTabsSkeleton: React.FC = () => {
  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: 'grey.100' }}>
        <Grid container spacing={2.5} wrap="nowrap">
          {_.times(7).map((_item, index) => (
            <Grid item key={index}>
              <Skeleton
                sx={{ borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}
                variant="rectangular"
                width="3rem"
                height="2rem"
              />
            </Grid>
          ))}
        </Grid>
      </Box>
      <Box sx={{ py: 2.5 }}>
        <Grid container alignItems="center" spacing={2.5}>
          <Grid item xs={12} md={7} lg={8}>
            <Skeleton variant="rectangular" height="30rem" />
          </Grid>
          <Grid item xs={12} md={5} lg={4}>
            <Skeleton variant="text" width="75%" />
            <Skeleton variant="rectangular" sx={{ mt: 1.5, mb: 0.5 }} height="2.5rem" />
            <Skeleton variant="rectangular" sx={{ mb: 3 }} height="2.5rem" width="50%" />
            {_.times(4).map((_item, index) => (
              <Skeleton key={index} variant="text" width={index === 5 ? '75%' : '100%'} />
            ))}
            <Skeleton variant="rectangular" sx={{ mt: 4 }} width="7.5rem" />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
